import React, { ComponentType, useEffect, useReducer, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import { useDispatch, useSelector } from "react-redux";
// import { generateTimeIntervalsTradingTimes } from "../../utils/tradingTimesObject";
import {
  CreateOrder,
  getPaymentDetails,
  confirmOrder,
  getVenueTimeSlotsList,
} from "../../Api.js";
import Styles from "./styles.module.scss";
import { SelectedOrderType, BackendTimeSlots } from "./types.d";
import Button from "../Widgets/Button";
import { useCheckCartItems } from "../../customHooks/useCheckCartItems";
import T from "i18n-react";

import {
  addDeliveryTimes,
  addPaymentDetails,
  changeStage,
  isPaymentDrawerOpen,
  resetState,
  setDeliveryPrice,
  setIsLoading,
  setSubTotalCost,
  setTransactionFee,
  changeOrderType,
  setPostcodeCheckStatus,
  setTotalPriceWithoutTips,
  setCartTax,
  setCartInclusiveTax,
  setServiceTax,
  setServiceInclusiveTax,
  setDeliveryInclusiveTax,
  setDeliveryTax,
} from "./reducer/PaymentActions";
import PaymentReducer from "./reducer/PaymentReducer";
import TableComponent from "./Table/TableComponent";
import DeliveryComponent from "./Delivery/DeliveryComponent";
import TimeSelectionComponent from "./TimeSelection/TimeSelectionComponent";
import PaymentComponent from "./PaymentDrawer/PaymentComponent";
import CardDetailsComponent from "./CardDetails/CardDetailsComponent";
import {
  getCartItemTaxAmount,
  getCartSubTotal,
  roundPriceOption,
} from "../../utils/pricingCalculator";
import { IAddCartItem } from "../../redux/Reducers/Cart";
import { itemTotalCount } from "../../utils/cartController";
import { _ChangeRedirect, _ChangeTable, _resetCart } from "../../redux/actions";
import { useHistory } from "react-router-dom";
import { checkAbvContainsFood } from "../../utils/checkAbvContainsFood";
import { useSnackbarMessages } from "../../yoello-lib/modules/components/snackbar/SnackbarContext";
import { LOGIN } from "../../constants/URL.const";
import OrderTypesComponent from "./OrderTypesComponent/OrderTypesComponent";
import MessageComponent from "./MessageInput/MessageComponent";
import TipComponent from "./Tips/TipComponent";
import PricingComponent from "./Pricing/PricingComponent";
import NavigationHeader from "../NavigationHeader/NavigationHeader";
import PageComponent from "../Page/PageComponent";
import { IPageComponentProps } from "../Page/types.d";
import useFormatCurrency from "../../yoello-lib/modules/localisation/useCurrency";
import { APIError } from "../../utils/APIErrorController";
import { isObject } from "../../utils/ObjectCheck";
import { CARDIFF_CASTLE } from "../../constants";
import { useVenueOpen } from "../../customHooks/useVenueOpen";
import { checkPostCodeInDeliveryRadius } from "../../utils/checkPostCodeInDeliveryRadius";
import { postcodeCheckStatusType } from "../Widgets/PostCodeChecker/PostCodeChecker";
import PostCodeAlert from "../Widgets/PostCodeChecker/PostCodeAlert/PostCodeAlert";
import { IPaymentContainerState, PaymentStages } from "./types.d";
import { IOrderBody } from "../../typings/IPayment";
import {
  addTaxes,
  calculateInclusiveTax,
  calculateAdditiveTax,
} from "../../yoello-lib/modules/utils/TaxController";
import { ITaxType } from "../../yoello-lib/modules/interfaces/ITaxes";
import { convertToUTCTime } from "../../yoello-lib/modules/utils/TimeConversion";
const stripePromise = loadStripe(process.env.REACT_APP_PUBLIC_STRIPE!);

interface IPaymentContainerProps extends IPageComponentProps {}

const paymentContainerInitalState: IPaymentContainerState = {
  userHasPaymentDetails: false,
  paymentDetails: undefined,
  isPaymentDrawOpen: false,
  isCardDetailsDrawerOpen: false,
  deliveryTimes: [],
  selectedOrderType: null,
  paymentStages: PaymentStages.PAYMENT,
  isDeliveryDrawOpen: false,
  selectedTable: null,
  areaName: null,
  deliveryAddress: {
    full_name: "",
    address: "",
    city: "",
    postcode: "",
  },
  disabledIds: [],
  isCollectionDrawOpen: false,
  selectedTime: null,
  isTableServiceDrawOpen: false,
  isUpdatingPaymentDetails: false,
  subTotalCost: 0,
  tipTotal: 0,
  totalPrice: 0,
  transactionFee: 0,
  isLoading: false,
  message: "",
  deliveryPrice: 0,
  postcodeCheckStatus: null,
  cartItemTaxAmount: null,
  serviceTaxAmount: null,
  cartItemInclusiveTaxAmount: null,
  sericeTaxInclusiveTaxAmount: null,
  deliveryTaxAmount: null,
  deliveryInclusiveTaxAmount: null,
};

/**
 * Payment container handles all the different state changes of creating an order
 * @param param0
 */
function PaymentContainer({
  User,
  isAuthenticated,
  retrieveToken,
  openSideDrawer,
}: IPaymentContainerProps) {
  const [state, dispatch] = useReducer(
    PaymentReducer,
    paymentContainerInitalState
  );
  const { sendSnackbarMessage } = useSnackbarMessages()!;
  const {
    paymentStages,
    selectedOrderType,
    selectedTable,
    areaName,
    deliveryTimes,
    deliveryAddress,
    userHasPaymentDetails,
    isCollectionDrawOpen,
    selectedTime,
    isTableServiceDrawOpen,
    isDeliveryDrawOpen,
    isPaymentDrawOpen,
    isCardDetailsDrawerOpen,
    subTotalCost,
    totalPrice,
    tipTotal,
    transactionFee,
    isLoading,
    paymentDetails,
    deliveryPrice,
    postcodeCheckStatus,
    message,
    cartItemTaxAmount,
    serviceTaxAmount,
    cartItemInclusiveTaxAmount,
    sericeTaxInclusiveTaxAmount,
    deliveryTaxAmount,
    deliveryInclusiveTaxAmount,
  } = state;
  const Venue = useSelector((state: any) => state.Venue);
  const Cart = useSelector((state: any) => state.Cart);
  const Group = useSelector((state: any) => state.Group);
  const CartID = useSelector((state: any) => state.CartID);
  const Taxes = useSelector((state: any) => state.Taxes);
  const SelectedMenuType = useSelector((state: any) => state.SelectedMenuType);
  const extraItems = useSelector((state: any) => state.MenuItemsAsExtra);
  const LoginRedirectToMainPage = useSelector(
    (state: any) => state.LoginRedirectToMainPage
  );
  const { checkCartAvailability } = useCheckCartItems();
  const { formatCurrency } = useFormatCurrency();
  const history = useHistory();
  const dispatcher = useDispatch();
  const [timeSlotsData, setTimeSlotsData] = useState<Array<BackendTimeSlots>>(
    []
  );

  const isVenueOpen = useVenueOpen(false);
  useEffect(() => {
    dispatch(changeOrderType(SelectedMenuType));
  }, [SelectedMenuType]);
  useEffect(() => {
    /**If the user is not authenticated make them go to the login */
    if (!isAuthenticated) {
      return history.push(LOGIN);
    }

    if (!isObject(Venue, true)) {
      sendSnackbarMessage(
        T.translate("Payment.Errors.NoVenue").toString(),
        "error"
      );
    }
    setDeliveryTimes();
    return () => {
      /**On unmount reset the state */
      dispatch(resetState(paymentContainerInitalState));
    };
    // eslint-disable-next-line
  }, []);
  useEffect(() => {
    /**Whenever cart updates, update the cart subtotal  */
    const cartSubTotal = getCartSubTotal(Cart);
    dispatch(setSubTotalCost(cartSubTotal));
    const taxAmount = getCartItemTaxAmount(Cart, Taxes, extraItems);
    dispatch(setCartTax(taxAmount.totalTaxAmount));
    dispatch(setCartInclusiveTax(taxAmount.totalInclusiveTaxAmount));

    // eslint-disable-next-line
  }, [Cart]);
  useEffect(() => {
    if (!paymentDetails && isAuthenticated) {
      setPaymentDetails();
    }
    // eslint-disable-next-line
  }, [paymentDetails, isAuthenticated]);
  useEffect(() => {
    if (subTotalCost > 0) {
      dispatch(setTotalPriceWithoutTips(subTotalCost));
    }
  }, [subTotalCost]);
  useEffect(() => {
    let pence = 0;
    let percentage = 0;
    let taxType;
    let taxPercentage = [];
    if (Venue?.venue_fees_and_taxes && Venue?.venue_fees_and_taxes.length > 0) {
      for (const fee of Venue.venue_fees_and_taxes) {
        if (fee.fee_type === "SERVICE") {
          pence = fee.fee_amount;
          percentage = fee.fee_percentage;
          taxType = fee.tax_inclusion_type;
          taxPercentage.push(fee.tax_percentage);
        }
      }
    } else if (
      Venue?.service_charge_pence_amount ||
      Venue?.service_charge_percentage_amount
    ) {
      pence = Venue.service_charge_pence_amount;
      percentage = Venue.service_charge_percentage_amount;
    }
    const serviceCharge =
      pence + (percentage * (totalPrice - (transactionFee + tipTotal))) / 100;

    if (taxType === ITaxType.ADDITIVE) {
      const serviceChargeTax = taxPercentage.reduce((prevValue, nextItem) => {
        const calc = calculateAdditiveTax(nextItem, serviceCharge);
        return prevValue + calc;
      }, 0);
      dispatch(setServiceTax(serviceChargeTax));
    } else {
      const serviceChargeTax = taxPercentage.reduce((prevValue, nextItem) => {
        const calc = calculateInclusiveTax(serviceCharge, nextItem);
        return prevValue + calc;
      }, 0);
      dispatch(setServiceInclusiveTax(serviceChargeTax));
    }
    dispatch(setTransactionFee(serviceCharge));
    // eslint-disable-next-line
  }, [Venue, totalPrice, tipTotal]);
  useEffect(() => {
    if (
      (Group?.group_service_charge_enabled &&
        Group?.group_nickname === CARDIFF_CASTLE) ||
      SelectedMenuType === SelectedOrderType.DELIVERY
    ) {
      let deliveryCharge = 0;
      let taxType;
      let taxPercentage = [];

      if (
        Venue?.venue_fees_and_taxes &&
        Venue?.venue_fees_and_taxes.length > 0
      ) {
        for (const fee of Venue.venue_fees_and_taxes) {
          if (fee.fee_type === "DELIVERY") {
            deliveryCharge = fee.fee_amount;
            taxType = fee.tax_inclusion_type;
            taxPercentage.push(fee.tax_percentage);
          }
        }
      } else if (Venue?.delivery_charge) {
        deliveryCharge = Venue.delivery_charge;
      }
      if (taxType === ITaxType.ADDITIVE) {
        const deliveryTax = taxPercentage.reduce((prevValue, nextItem) => {
          const calc = calculateAdditiveTax(nextItem, deliveryCharge);
          return prevValue + calc;
        }, 0);
        dispatch(setDeliveryTax(deliveryTax));
      } else {
        const deliveryTax = taxPercentage.reduce((prevValue, nextItem) => {
          const calc = calculateInclusiveTax(deliveryCharge, nextItem);
          return prevValue + calc;
        }, 0);
        dispatch(setDeliveryInclusiveTax(deliveryTax));
      }
      dispatch(setDeliveryPrice(deliveryCharge));
    }
    // eslint-disable-next-line
  }, [Group, Venue]);
  /**generates the deliver/collection times depending on the day */
  async function setDeliveryTimes() {
    if (
      Venue &&
      SelectedMenuType !== SelectedOrderType.TABLE &&
      isAuthenticated
    ) {
      try {
        const token = await retrieveToken();
        const TimeSlotsData = await getVenueTimeSlotsList(
          token,
          Venue.venue_nickname,
          SelectedMenuType
        );
        let TimeSlotsList: Array<BackendTimeSlots> =
          TimeSlotsData.data.data.time_slots;
        TimeSlotsList.sort(function (a, b) {
          return a.venue_time.localeCompare(b.venue_time);
        });
        setTimeSlotsData(TimeSlotsList);
        dispatch(addDeliveryTimes(TimeSlotsList));

        // **** OLD WAY OF DOING IT FRONT_END ONLY ****
        // const day = moment().format("dddd").toLowerCase();
        // if ("trading_times" in Venue) {
        //   const tradingTimes = Venue ?.trading_times[day] || undefined;
        //   if (tradingTimes) {
        //     console.log("dispatching");
        //     console.log("====================================");
        //     console.log(
        //       generateTimeIntervalsTradingTimes(
        //         tradingTimes,
        //         SelectedMenuType === SelectedOrderType.DELIVERY
        //           ? Venue.delivery_max_lead_time
        //           : Venue.food_prep_time
        //       )
        //     );
        //   }
        // }
      } catch (error) {}
    }
  }
  const dispatchPaymentDetails = (
    details: any,
    userHasPaymentDetails: boolean
  ) => {
    dispatch(addPaymentDetails(details, userHasPaymentDetails));
  };
  async function setPaymentDetails() {
    dispatch(setIsLoading(true));
    const token = await retrieveToken();
    try {
      if (!token) {
        return;
      }
      const paymentDetails = await getPaymentDetails(token);
      dispatchPaymentDetails(paymentDetails.data.data, true);
      dispatch(setIsLoading(false));
    } catch (error) {
      if (error.response) {
        const status = error.response.data.status;
        if (status === 404) {
          dispatchPaymentDetails(undefined, false);
          dispatch(setIsLoading(false));
        }
      }
    }
  }
  const generateOrderBody = (isUsingPaymentRequest: boolean) => {
    let selectedTimeSlot = timeSlotsData.find((item: BackendTimeSlots) => {
      return item === selectedTime;
    });
    let UTCtimeStamp = selectedTimeSlot?.time_utc;
    let VenueTimeStamp = selectedTimeSlot?.venue_time;
    // if (timeStamp !== null) {
    // const split = timeStamp.split(":");
    // const dt = new Date();

    // timeStamp = new Date(
    //   dt.getFullYear(),
    //   dt.getMonth(),
    //   dt.getDate(),
    //   parseInt(split[0]),
    //   parseInt(split[1])
    // );

    const taxTotal = addTaxes(
      cartItemTaxAmount,
      serviceTaxAmount,
      deliveryTaxAmount
    );

    const orderBody: IOrderBody = {
      venue_id: Venue.id,
      intent: isUsingPaymentRequest,
      comment: message,
      delivery_charge:
        SelectedMenuType === SelectedOrderType.DELIVERY ||
        (Group?.group_service_charge_enabled &&
          Group?.group_nickname === CARDIFF_CASTLE)
          ? deliveryPrice
          : null,
      gratuity: roundPriceOption(tipTotal),
      delivery_table:
        selectedOrderType === SelectedOrderType.TABLE ? selectedTable : null,
      total_price: roundPriceOption(totalPrice + taxTotal),
      table_area:
        selectedOrderType === SelectedOrderType.TABLE ? areaName : null,
      order_type: selectedOrderType,
      takeaway_timeslot:
        selectedOrderType === SelectedOrderType.TABLE ? null : UTCtimeStamp,
      venue_takeaway_timeslot: VenueTimeStamp,
      delivery_address: deliveryAddress,
      menu_items: [],
      group_id: undefined,
      cart_id: CartID,
    };
    if (Group?.group_id && Group?.group_nickname === CARDIFF_CASTLE) {
      orderBody.group_id = Group?.group_id;
    }
    const menuItems = Cart.map((cartItem: IAddCartItem) => {
      let extras: { extra_id: string; extra_pricing_option_key: string }[] = [];
      if (cartItem.extras) {
        for (const extraKey in cartItem.extras) {
          const extraArray = cartItem.extras[extraKey];
          extraArray.forEach((extra) => {
            extras.push({
              extra_id: extra.id,
              extra_pricing_option_key: extra.priceName,
            });
          });
        }
      }
      const { menuItem, measure, itemCount, preferences } = cartItem;
      return {
        menu_item_id: menuItem.menu_item_id,
        quantity: itemTotalCount(menuItem, measure, itemCount),
        pricing_option_key: measure,
        extras: extras,
        modifiers: [],
        preferences: preferences
          ? Object.keys(preferences).map((preference) => {
              return preferences[preference];
            })
          : [],
      };
    });
    orderBody.menu_items = menuItems;
    return orderBody;
  };
  /**The final step to creating an order */
  async function completeOrder(isUsingPaymentRequest: boolean) {
    try {
      if (!canPaymentBeProcessed()) {
        throw new Error("Could not process");
      }
      dispatch(setIsLoading(true));
      const orderBody = { ...generateOrderBody(isUsingPaymentRequest) };
      const token = await retrieveToken();
      const createOrderObject = await CreateOrder(orderBody, token, Venue.id);
      if (isUsingPaymentRequest) {
        return createOrderObject;
      } else {
        const orderId = createOrderObject.data.data.order_reference_number;
        onSuccessfulOrder(orderId);
      }
    } catch (error) {
      console.log({ error });
      let errMessage = T.translate("Payment.Errors.CreateOrderError") as string;
      if (error.response) {
        const status = error.response.data.status;
        if (status >= 400 && status < 500) {
          if (status === 401) {
            localStorage.removeItem("user_token");
            history.push(LOGIN);
          } else {
            const errors = error.response.data.data.errors;
            console.log("====================================");
            console.log(errors);
            console.log("====================================");
            errMessage = APIError(errors);
          }
        }
      }
      sendSnackbarMessage(errMessage, "error");
    } finally {
      dispatch(setIsLoading(false));
    }
  }
  function renderComponents() {
    if (paymentStages === PaymentStages.PAYMENT) {
      return (
        <div className={Styles.ChooseMethod}>
          <OrderTypesComponent
            deliveryTimes={deliveryTimes}
            deliveryAddress={deliveryAddress}
            dispatch={dispatch}
            selectedTableArea={areaName}
            selectedTableNumber={selectedTable}
            selectedTime={selectedTime}
            isVenueOpen={isVenueOpen}
          />
          <PostCodeAlert postcodeCheckStatus={postcodeCheckStatus} />
          <MessageComponent dispatch={dispatch} />
          <TipComponent
            dispatch={dispatch}
            transactionFee={transactionFee}
            itemCost={subTotalCost}
            deliveryCharge={deliveryPrice}
            totalCost={totalPrice}
            tipTotal={tipTotal}
            cartItemTaxAmount={cartItemTaxAmount}
            serviceTaxAmount={serviceTaxAmount}
            deliveryTaxAmount={deliveryTaxAmount}
          />
          <PricingComponent
            tip={tipTotal}
            totalCost={totalPrice}
            transactionFee={transactionFee}
            itemCost={subTotalCost}
            deliveryCharge={deliveryPrice}
            cartItemTaxAmount={cartItemTaxAmount}
            serviceTaxAmount={serviceTaxAmount}
            cartItemInclusiveTaxAmount={cartItemInclusiveTaxAmount}
            sericeTaxInclusiveTaxAmount={sericeTaxInclusiveTaxAmount}
            deliveryTaxAmount={deliveryTaxAmount}
            deliveryInclusiveTaxAmount={deliveryInclusiveTaxAmount}
          />
        </div>
      );
    }
  }
  function onSuccessfulOrder(orderId: string) {
    if (selectedOrderType === SelectedOrderType.TABLE) {
      dispatcher(_ChangeTable(selectedTable));
    }
    dispatcher(_resetCart());
    dispatcher(_ChangeRedirect(null));
    history.push(getRedirectURL() + "#OriderId=true", {
      orderId: orderId,
      OrderType: selectedOrderType,
      TimeSlot: selectedTime ? convertToUTCTime(selectedTime.venue_time) : "",
      deliveryAddress: deliveryAddress,
      tableArea: areaName,
    });
  }

  function getRedirectURL() {
    if (!isObject(Venue, true)) {
      return "/";
    }
    if (LoginRedirectToMainPage === "PaymentA") {
      return `/g/${Group.group_name_public}/${Venue.venue_nickname}/menu`;
    } else {
      return "/v/" + Venue.venue_nickname + "/menu";
    }
  }
  /**Checks if the  correct order details have been set up */
  function canPaymentBeProcessed() {
    let errMsg = T.translate("Payment.Errors.PaymentCouldNotProceed");
    if (selectedOrderType === null) {
      errMsg = T.translate("Payment.Errors.SelectOrderType");
    } else if (totalPrice < 30) {
      errMsg = T.translate("Payment.Errors.BelowMinimum");
    } else if (
      selectedOrderType === SelectedOrderType.TABLE &&
      selectedTable === null
    ) {
      errMsg = T.translate("Payment.Errors.WithoutVenueArea");
    } else if (
      selectedOrderType === SelectedOrderType.CLICK &&
      selectedTime === null
    ) {
      errMsg = T.translate("Payment.Errors.WithoutCollectionTime");
    } else if (
      selectedOrderType === SelectedOrderType.DELIVERY &&
      (selectedTime === null ||
        deliveryAddress.full_name.length === 0 ||
        deliveryAddress.address.length === 0 ||
        deliveryAddress.postcode.length === 0)
    ) {
      errMsg = T.translate("Payment.Errors.WithoutDeliveryInfo");
    } else if (
      Group?.group_abv_food_threshold &&
      Group?.group_nickname === CARDIFF_CASTLE
    ) {
      if (!checkAbvContainsFood(Cart, Group?.group_abv_food_threshold)) {
        const price = formatCurrency(Group?.group_abv_food_threshold);
        errMsg = T.translate("Payment.Errors.CartMustContainMin", {
          price: price,
        });
        // NEEDS currency localization
      } else {
        return true;
      }
    } else {
      return true;
    }
    sendSnackbarMessage(errMsg as string, "error");
    return false;
  }
  function backFunction(deletedItems: any[] = []) {
    if (paymentStages === PaymentStages.PAYMENT) {
      history.push(getRedirectURL(), { isCartOpen: true, deletedItems });
    } else {
      dispatch(changeStage(PaymentStages.PAYMENT));
    }
  }

  async function checkPostCodeRadius() {
    // TO DO: move this logic into a reuseable component
    const userDeliveryAddress = `${Venue.address_country}, ${deliveryAddress.address}, ${deliveryAddress.city}, ${deliveryAddress.postcode}`;
    if (Venue.delivery_radius_km) {
      await checkPostCodeInDeliveryRadius(
        Venue,
        userDeliveryAddress,
        Venue.delivery_radius_km,
        afterResponseFunction
      );
    }
  }

  function afterResponseFunction(InRadius) {
    // Blah Blah Blah
    if (InRadius) {
      dispatch(
        setPostcodeCheckStatus(postcodeCheckStatusType.InDeliveryRadius)
      );
    } else {
      dispatch(
        setPostcodeCheckStatus(postcodeCheckStatusType.OutOfDeliveryRadius)
      );
    }
  }
  const checkCart = async () => {
    const { isSuccess, disabledItems } = await checkCartAvailability();
    if (!isSuccess) {
      backFunction(disabledItems);
    }
  };
  return (
    <Elements
      stripe={stripePromise}
      options={{
        fonts: [
          { cssSrc: "https://fonts.googleapis.com/css?family=Open+Sans" },
        ],
      }}
    >
      <div className={Styles.Payment}>
        <NavigationHeader
          openSideDrawer={openSideDrawer}
          backURL={backFunction}
        />
        {renderComponents()}
        {paymentStages === PaymentStages.PAYMENT && (
          <div className={Styles.BottomBar}>
            {selectedOrderType === null && (
              <T.p
                className={Styles.OrderTypeNotSelectedText}
                text={{ key: `Payment.OrderTypeNotSelected` }}
              />
            )}
            {paymentStages === PaymentStages.PAYMENT &&
              selectedOrderType !== null && (
                <div className="Flex2">
                  <Button
                    iconClassName="consumer-right-arrow"
                    isYoelloBtn
                    title={"ProceedPayment"}
                    disabled={
                      postcodeCheckStatus ===
                        postcodeCheckStatusType.OutOfDeliveryRadius || isLoading
                    }
                    dataComponentName={!isLoading && "PaymentButton"}
                    onClick={() => {
                      if (canPaymentBeProcessed() && !isLoading) {
                        console.log("checkCartAvailability", checkCart());
                        dispatch(isPaymentDrawerOpen(true));
                      }
                    }}
                  />
                </div>
              )}
          </div>
        )}

        <PaymentComponent
          isOpen={isPaymentDrawOpen}
          dispatch={dispatch}
          dispatcher={dispatcher}
          retrieveToken={retrieveToken}
          paymentDetails={paymentDetails}
          paymentFunction={completeOrder}
          isLoading={isLoading}
          totalPrice={totalPrice}
          userHasPaymentDetails={userHasPaymentDetails}
          checkPaymentProceed={canPaymentBeProcessed}
          successfulTransaction={onSuccessfulOrder}
          confirmOrder={confirmOrder}
          errorMessenger={(message: string) =>
            sendSnackbarMessage(message, "error")
          }
          cartItemTaxAmount={cartItemTaxAmount}
          serviceTaxAmount={serviceTaxAmount}
          deliveryTaxAmount={deliveryTaxAmount}
        />
        <TimeSelectionComponent
          isOpen={isCollectionDrawOpen}
          selectedTime={selectedTime}
          dispatch={dispatch}
          deliveryTimes={deliveryTimes}
          orderType={SelectedMenuType}
        />
        <TableComponent
          isOpen={isTableServiceDrawOpen}
          dispatch={dispatch}
          areaName={areaName}
          selectedTable={selectedTable}
        />
        <CardDetailsComponent
          isOpen={isCardDetailsDrawerOpen}
          paymentDetails={paymentDetails}
          retrieveToken={retrieveToken}
          dispatch={dispatch}
          updatePaymentDetails={dispatchPaymentDetails}
        />

        <DeliveryComponent
          isOpen={isDeliveryDrawOpen}
          dispatch={dispatch}
          checkPostCodeRadius={checkPostCodeRadius}
        />
      </div>
    </Elements>
  );
}
export default PageComponent(PaymentContainer as ComponentType);
